import * as React from "react";
const SvgCancel = props => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 22 22" {...props}><path d="M22 19.71 19.71 22l-8.7-8.71L2.3 22 .01 19.71 8.72 11 .01 2.29 2.3 0l8.71 8.71L19.71 0 22 2.29 13.29 11Z" /></svg>;
export default SvgCancel;